import { render } from "./NewAdView.vue?vue&type=template&id=1ecd04a0"
import script from "./NewAdView.vue?vue&type=script&lang=js"
export * from "./NewAdView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__